import React from "react";
import styled from "styled-components";
import TeamLinksDropdown from "./TeamLinksDropdown";

const StyledTeamInfoLi = styled.li`
  & > ul.flex {
    flex-flow: row wrap;
  }

  text-transform: none;
`;

const NavSideTeamInfo = () => {
  return (
    <StyledTeamInfoLi>
      <ul className={"flex"}>
        <li>
          <TeamLinksDropdown />
        </li>
      </ul>
    </StyledTeamInfoLi>
  );
};

export default NavSideTeamInfo;
